export const TAKAFUL_PROVIDER_LANGUAGE = {
  takaful_provider_add_information: "Information",
  takaful_provider_add_company_name: "Name",
  takaful_provider_add_company_name_msg: "Name is required",
  takaful_provider_add_company_name_space_error: "Name is invalid",
  takaful_provider_add_company_address_space_error: "Address is invalid",
  takaful_provider_add_company_name_limit: "Character must be smaller then 50",
  takaful_provider_add_contact_label: "Contact Number",
  takaful_provider_add_company_email_label: "Email Address",
  takaful_provider_add_company_email_error: "Email Address is required",
  takaful_provider_add_company_email_validation: "Invalid Email Address",
  takaful_provider_add_company_address_label: "Address",
  takaful_provider_add_company_address_error: "Address is required",
  takaful_provider_add_company_address_validation: "Character must be smaller then 250",
  takaful_provider_add_company_city_label: "City",
  takaful_provider_add_company_city_error: "City is required",
  takaful_provider_add_company_state_label: "Company State",
  takaful_provider_add_company_state_error: "Company State is required",
  takaful_provider_add_country_label: "Company Country",
  takaful_provider_add_country_error: "Company Country is required",
  takaful_provider_add_upload: "Upload",
  takaful_provider_add_upload_error: "Image is required",
  takaful_provider_add_bank_name: "Bank Name",
  takaful_provider_add_line_of_business: "Line of Business",
  takaful_provider_add_account_detail: "Account Detail",
  takaful_provider_add_Exclusions: "Exclusions",
  takaful_provider_add_text: "Add",
  takaful_provider_add_account_title: "Account Title",
  takaful_provider_add_account_number: "Account Number",
  takaful_provider_view_name: "Takaful Provider Name",
  takaful_provider_view_status: "Status",
  takaful_provider_view_top_bar_search: "Search",
  takaful_provider_view_line_of_business: "Line of Business",
  takaful_provider_view_provider_list: "Takaful Provider List",
  takaful_provider_view_action: "Action",
  takaful_provider_POC_text: "Point of Contact",
  takaful_provider_POC_add_poc: "Point of Contact",
  takaful_provider_POC_view_email: "Email Address",
  takaful_provider_POC_view_line_of_business: "Line of Business",
  takaful_provider_POC_view_designation: "Designation",
  takaful_provider_POC_view_city: "City",
  takaful_provider_POC_view_top_bar_search: "Search",
  takaful_provider_POC_add_save: "Save",
  takaful_provider_POC_add_name: "Name",
  takaful_provider_POC_add_country: "Country",
  takaful_provider_POC_add_number: "Contact Number",
  takaful_provider_POC_add_name_err: "Name is required",
  takaful_provider_POC_add_name_length_err: "Name must be smaller than 50 characters",
  takaful_provider_POC_add_contact: "Contact Number",
  takaful_provider_POC_add_contact_err: "Contact Number is required",
  takaful_provider_POC_add_email: "Email Address",
  takaful_provider_POC_add_email_err: "Email Address is required",
  takaful_provider_POC_add_email_err2: "Invalid Email Address",
  takaful_provider_POC_add_designation: "Designation",
  takaful_provider_POC_add_designation_err: "Designation is required",
  takaful_provider_POC_add_designation_err1: "Name must be smaller than 50 characters",
  takaful_provider_POC_add_city: "City",
  takaful_provider_POC_add_city_err: "City is required",
  takaful_provider_POC_add_line_of_business: "Line of Business",
  takaful_provider_POC_add_line_of_business_err: "Line of business is required field",
  takaful_provider_ACCOUNT_add_bank_name: "Bank Name",
  takaful_provider_ACCOUNT_add_line_of_business: "Line of Business",
  takaful_provider_ACCOUNT_add_account_detail: "Account Detail",
  takaful_provider_ACCOUNT_add_account_number: "Account Number",
  takaful_provider_ACCOUNT_add_business_required_error: "Line Of Business is required field",
  takaful_provider_ACCOUNT_add_bank_name_required_error: "Bank Name is required field",
  takaful_provider_ACCOUNT_add_account_title_required_error: "Account Title is required field",
  takaful_provider_ACCOUNT_add_account_number_required_error: "Account Number is required field",
  takaful_provider_doc_view_document_name: "Document Name",
  takaful_provider_doc_view_LOB: "Line Of Business",
  takaful_provider_doc_view_type: "Type",
  takaful_provider_doc_view_text: "Documents",
  takaful_provider_doc_view_top_bar_search: "Search",

  takaful_provider_doc_add_name: "Documents Name",
  takaful_provider_doc_add_doc_type: "Documents Type",
  takaful_provider_doc_add_name_err: "Document name is required",
  takaful_provider_doc_add_name_length_err: "Name must be smaller than 50 characters",
  takaful_provider_doc_add_name_invalid_err: "Document Name is invalid",
  takaful_provider_doc_add_LOB: "Line of Business",
  takaful_provider_doc_add_LOB_err: "Line Of business is required",
  takaful_provider_doc_add_doc_type_err: "Document type is required",
  takaful_provider_doc_upload_doc_err: "Upload document is required",
  takaful_provider_doc_upload_doc: "Upload Document",
  takaful_provider_doc_upload_text: "Upload",
  takaful_provider_doc_last_updated_text: "Last Updated",

  takaful_provider_info_text: "Information",
  takaful_provider_doc_text: "Documents",
  takaful_provider_performance_indicators: "Performance Indicators",
  takaful_provider_performance_indicators_Filter_line_of_business: "Line Of Business",
  takaful_provider_performance_indicators_table_line_of_business: "Line Of Business",
  takaful_provider_performance_indicators_table_claim_payout_ratio: "Claim Payout Ratio",
  takaful_provider_performance_indicators_table_pacra_rating: "PACRA Rating",
  takaful_provider_performance_indicators_table_claim_tat: "Claim Turn Around Time (Days)",
  takaful_provider_performance_indicators_table_last_updated: "Last Updated",
  takaful_provider_performance_indicators_table_updated_by: "Updated By",
  takaful_provider_performance_indicators_add: "Performance Indicators",
  takaful_provider_Performance_indicators_add_line_of_business: "Line Of Business",
  takaful_provider_performance_indicators_add_claim_payout_ratio: "Claim Payout Ratio",
  takaful_provider_performance_indicators_add_pacra_rating: "PACRA Rating",
  takaful_provider_performance_indicators_add_claim_tat: "Claim Turn Around Time",
  takaful_provider_performance_indicators_add_save: "Save",
  takaful_provider_performance_indicators_add_line_of_business_err: "Line of Business is a required field",
  takaful_provider_performance_indicators_add_claim_payout_ratio_err: "Claim Payout Ratio is a required field",
  takaful_provider_performance_indicators_add_pacra_rating_err: "PACRA Rating is a required field",
  takaful_provider_performance_indicators_add_claim_payout_ratio_error_min: "Claim Payout Ratio should be greater then 0",
  takaful_provider_performance_indicators_add_claim_payout_ratio_error_decimal: "Claim Payout Ratio can't be decimal",
  takaful_provider_performance_indicators_text: "Performance Indicators",
  takaful_provider_activity_text: "Activity Log",
  takaful_provider_activity_heading: "Activity Log",
  takaful_provider_activity_date: "Date",
  takaful_provider_activity_user: "User",
  takaful_provider_activity_action: "Action",
  takaful_provider_activity_activity: "Activity",

  takaful_provider_performance_indicators_add_claim_payout_ratio_error_max: "Claim Payout Ratio should be less then 1000",
  takaful_provider_performance_indicators_add_claim_tat_error_min: "Claim Turn Around Time should be greater then 0",
  takaful_provider_performance_indicators_add_claim_tat_error_max: "Claim Turn Around Time should not be less then 100",
  takaful_provider_performance_indicators_add_claim_tat_err: "Claim Turn Around Time is a required field",
  takaful_provider_Exclusion_listing_not_identified: "Not Identified",
  takaful_provider_Exclusion_listing_closed: "Closed",
  takaful_provider_Exclusion_listing_communicated: "Communicated",
  takaful_provider_Exclusion_listing_identified: "Identified",
  takaful_provider_Exclusion_listing_resolved: "Resolved",
  takaful_provider_Exclusion_listing_cancelled: "Canceled",
  takaful_provider_Exclusion_Filter_line_of_business: "Line of Business",
  takaful_provider_Exclusion_add_general_exclusion: "General Exclusion",
  takaful_provider_Exclusion_add_general_exclusion_err: "General Exclusion is required",
  takaful_provider_Exclusion_add_line_of_business: "Line of Business",
  takaful_provider_Exclusive_add_line_of_business_err: "Line of business is required field",
  takaful_provider_Exclusive_add_save: "Save",
  takaful_provider_Exclusive_dropdown_health: "Health",
  takaful_provider_Exclusive_dropdown_life: "Life",
  takaful_provider_Exclusive_dropdown_travel: "Travel",

  takaful_provider_config_LOB: "Line Of Business",
  takaful_provider_config_license: "License",
  takaful_provider_config_admin_cost: "Admin Cost",
  takaful_provider_config_view_text: "Configuration",

  takaful_provider_config_add_license: "Select License",
  takaful_provider_config_add_license_err: "License is required.",
  takaful_provider_config_admin_cost_err: "Admin cost is required.",

  takaful_provider_discount_center: "Discount Center",
  takaful_provider_discount_center_search: "Search Group Name",
  takaful_provider_discount_center_group_name: "Group Name",
  takaful_provider_discount_center_discount_range: "Discount Range(%)",
  takaful_provider_discount_center_add_select_group: "Select Group",
  takaful_provider_discount_center_add_select_group_error: "Group is required",
  takaful_provider_discount_center_add_search_groups: "Search Groups",
  takaful_provider_discount_center_edit_name: "Name",
  takaful_provider_discount_center_edit_min_discount: "Minimum (%)",
  takaful_provider_discount_center_edit_max_discount: "Maximum (%)",
  takaful_provider_discount_center_edit_variable_discount: "Variable Discount",
  takaful_provider_discount_center_edit_max_discount_error: "Maximum Discount is required",
  takaful_provider_discount_center_edit_min_discount_min_limit_error: "Discount (Minimum) can't be less then 0",
  takaful_provider_discount_center_edit_min_discount_max_limit_error: "Discount (Minimum) can't be greater then two digit",
  takaful_provider_discount_center_edit_max_discount_min_limit_error: "Discount (Maximum) can't be less then 0",
  takaful_provider_discount_center_edit_max_discount_max_limit_error: "Discount (Maximum) can't be greater then two digit",
  takaful_provider_discount_center_edit_max_discount_min_greater_max_error: "Discount (Minimum) should be less then Discount (Maximum)",
  takaful_provider_discount_center_edit_min_discount_decimal_value_error: "Decimal Values are not allowed",
  takaful_provider_discount_center_edit_max_discount_decimal_value_error: "Decimal Values are not allowed",

  takaful_provider_cash_less_workshops: "Discount Center",
  takaful_provider_cash_less_workshops_search: "Search Group Name",
  takaful_provider_cash_less_workshops_group_name: "Group Name",
  takaful_provider_cash_less_workshops_discount_range: "Discount Range(%)",
  takaful_provider_cash_less_workshops_add_select_group: "Select Group",
  takaful_provider_cash_less_workshops_add_select_group_error: "Group is required",
  takaful_provider_cash_less_workshops_add_search_groups: "Search Groups",
  takaful_provider_cash_less_workshops_edit_name: "Name",
  takaful_provider_cash_less_workshops_edit_min_discount: "Minimum (%)",
  takaful_provider_cash_less_workshops_edit_max_discount: "Maximum (%)",
  takaful_provider_cash_less_workshops_edit_variable_discount: "Variable Discount",
  takaful_provider_cash_less_workshops_edit_max_discount_error: "Maximum Discount is required",
  takaful_provider_cash_less_workshops_edit_min_discount_min_limit_error: "Discount (Minimum) can't be less then 0",
  takaful_provider_cash_less_workshops_edit_min_discount_max_limit_error: "Discount (Minimum) can't be greater then two digit",
  takaful_provider_cash_less_workshops_edit_max_discount_min_limit_error: "Discount (Maximum) can't be less then 0",
  takaful_provider_cash_less_workshops_edit_max_discount_max_limit_error: "Discount (Maximum) can't be greater then two digit",
  takaful_provider_cash_less_workshops_edit_max_discount_min_greater_max_error: "Discount (Minimum) should be less then Discount (Maximum)",
  takaful_provider_cash_less_workshops_edit_min_discount_decimal_value_error: "Decimal Values are not allowed",
  takaful_provider_cash_less_workshops_edit_max_discount_decimal_value_error: "Decimal Values are not allowed",
  takaful_provider_cash_less_workshop_variable_discount: "Variable Discount",

  takaful_provider_panel_hospitals_text: "Panel Hospitals",
  takaful_provider_hospital_text: "Hospital",
  takaful_provider_panel_hospitals_heading: "Panel Hospitals",
  takaful_provider_panel_hospitals_listing_group_name: "Group Name",
  takaful_provider_panel_hospitals_listing_search: "Search Group Name",
  takaful_provider_panel_hospitals_add_select_group: "Select Group",
  takaful_provider_panel_hospitals_add_select_group_error: "Group is required",

  takaful_provider_cash_less_workshops_text: "Cashless Workshops",
  takaful_provider_cash_less_workshops_heading: "Cashless Workshops",
  takaful_provider_cash_less_workshops_listing_group_name: "Group Name",
  takaful_provider_cash_less_workshops_listing_search: "Search Group Name",

  takaful_provider_image_size_error: "Image must be smaller than 5MB",
  takaful_provider_image_format_error: "File must be image",

  takaful_provider_partner_premises_text: "Premises",

  takaful_provider_cash_less_workshop: "Cashless Workshops",
  takaful_provider_cash_less_workshop_search: "Search Group Name",
  takaful_provider_cash_less_workshop_group_name: "Group Name",
  takaful_provider_cash_less_workshop_discount_range: "Discount Range(%)",
  takaful_provider_cash_less_workshop_add_select_group: "Select Group",
  takaful_provider_cash_less_workshop_add_select_group_error: "Group is required",
  takaful_provider_cash_less_workshop_add_search_groups: "Search Groups",
  takaful_provider_cash_less_workshop_edit_name: "Name",
  takaful_provider_cash_less_workshop_edit_min_discount: "Minimum (%)",
  takaful_provider_cash_less_workshop_edit_max_discount: "Maximum (%)",
  takaful_provider_cash_less_workshop_edit_variable_discount: "Variable Discount",
  takaful_provider_cash_less_workshop_edit_max_discount_error: "Maximum Discount is required",
  takaful_provider_cash_less_workshop_edit_min_discount_min_limit_error: "Discount (Minimum) can't be less then 0",
  takaful_provider_cash_less_workshop_edit_min_discount_max_limit_error: "Discount (Minimum) can't be greater then two digit",
  takaful_provider_cash_less_workshop_edit_max_discount_min_limit_error: "Discount (Maximum) can't be less then 0",
  takaful_provider_cash_less_workshop_edit_max_discount_max_limit_error: "Discount (Maximum) can't be greater then two digit",
  takaful_provider_cash_less_workshop_edit_max_discount_min_greater_max_error: "Discount (Minimum) should be less then Discount (Maximum)",
  takaful_provider_cash_less_workshop_edit_min_discount_decimal_value_error: "Decimal Values are not allowed",
  takaful_provider_cash_less_workshop_edit_max_discount_decimal_value_error: "Decimal Values are not allowed"
};
